<template>
  <div class="master-item">
    <div class="master-card">
      <img class="img" :src="head_img" />
      <div class="master-info flex-direction flex justify-center">
        <div class="name flex align-center">
          <div>
            {{ nickname }}
          </div>
          <div class="moneySave">
            <img class="baoMoney" :src="baoIcon||'../../../../assets/images/logo.png'" />
          </div>
        </div>
        <div class="desc padding-top-4">
          <!-- <span class="mrs">近三个月被投诉{{ thressMonthsCount }}次</span> -->
          <!-- <span class="pions">查看评价</span> -->
        </div>
        <div class="desc padding-tb-4">
          <span class="mrs"> 近1个月完成{{ lastMonthNumber||0 }}单 </span>
          <!-- <span class="pions">查看员工图</span> -->
          <span class="pions">总共完成{{worker_order||0}}单</span>

        </div>
        <!-- <div class="desc margin-top-xs">总共完成{{worker_order||0}}单</div> -->
        <div class="num">合作{{cooperateNumber||0}}次</div>
        <div class="textarea margin-top-xs" v-if="message != ''">
          <div class="">师傅留言：{{ message }}</div>
        </div>
      </div>
      <div class="contact">
        <div class="text1">报价：{{ offer }}</div>
        <div class="text margin-top" v-if="tolls_time">上门时间：{{ tolls_time }}</div>
      </div>
      <div class="contact">
        <div class="text">综合评分：{{ score }}分</div>
      </div>
      <div class="handle margin-right">
        <Button size="small" class="finish-btn" @click="showFinishedOrders">历史完工图</Button>
        <Button type="primary" size="small" class="btn" v-if="detail_status>3" @click="$router.push({ name: 'order_complaint', params: { id: order_id } })">投诉师傅</Button>
        <Button type="primary" size="small" class="btn" @click="assign()" v-if="detail_status == 2">指派TA</Button>
        <Button type="primary" size="small" class="btn" v-if="worker_id != detail_worker_id && detail_status == 3" :disabled="true">指派TA</Button>
        <Button type="primary" size="small" class="btn" @click="$router.push({ name: 'order_pay', params: { id: order_id } })" v-if="worker_id == detail_worker_id && detail_status == 3"
          >已指派去付款</Button
        >
        <div class="tips" v-if="detail_status < 4 || worker_id != detail_worker_id">付款后可看见师傅电话</div>
        <div class="tips" v-if="detail_status > 3 && worker_id == detail_worker_id">
          <div>师傅电话</div>
          <div>{{ phone }}</div>
        </div>
      </div>
    </div>
    <Modal
      v-model="finishedModalVisible"
      title="历史完工图"
      width="860"
      footer-hide
      class-name="finished-order-modal">
      <div class="finished-panel">
        <div class="finished-loading" v-if="finishedLoading">加载中...</div>
        <div class="finished-empty" v-else-if="finishedOrders.length <= 0">暂无历史完工图</div>
        <div class="finished-list" v-else>
          <div class="finished-item" v-for="(item, index) in finishedOrders" :key="index">
            <div class="finished-meta">
              <div class="finished-title">{{ getFinishedTitle(item, index) }}</div>
              <div class="finished-desc">
                <span v-if="getRecordValue(item, ['order_no', 'number', 'order_number'])">订单：{{ getRecordValue(item, ['order_no', 'number', 'order_number']) }}</span>
                <span v-if="getRecordValue(item, ['contacts', 'contact', 'nickname', 'user_name', 'name'])">联系人：{{ getRecordValue(item, ['contacts', 'contact', 'nickname', 'user_name', 'name']) }}</span>
                <span v-if="getRecordValue(item, ['complete_time', 'finished_time', 'finish_time'])">完成：{{ getRecordValue(item, ['complete_time', 'finished_time', 'finish_time']) }}</span>
              </div>
            </div>
            <div class="finished-images" v-if="getFinishedImages(item).length > 0">
              <el-image
                class="finished-image"
                v-for="(img, imgIndex) in getFinishedImages(item)"
                :key="imgIndex"
                :src="img"
                :preview-src-list="getFinishedImages(item)"
                fit="cover">
              </el-image>
            </div>
            <div class="finished-no-image" v-else>暂无图片</div>
          </div>
        </div>
        <div class="finished-page" v-if="finishedTotal > finishedSize">
          <Page
            :current="finishedPage"
            :page-size="finishedSize"
            :total="finishedTotal"
            size="small"
            show-total
            @on-change="changeFinishedPage" />
        </div>
      </div>
    </Modal>
    <div class="service-record-wrap">
      <div class="service-record-head">
        <div>
          <div class="service-record-title">已服务信息</div>
          <div class="service-record-sub">历史服务记录仅作雇佣参考</div>
        </div>
        <div class="service-record-total">共 {{ serviceRecords.length }} 条</div>
      </div>
      <div class="service-loading" v-if="serviceLoading">加载中...</div>
      <div class="service-empty" v-else-if="serviceRecords.length <= 0">暂无已服务记录</div>
      <div class="service-list" v-else>
        <div class="service-item" v-for="(item, index) in serviceRecords" :key="index">
          <div class="service-item-top">
            <div class="service-name">{{ getRecordTitle(item, index) }}</div>
            <div class="service-status" v-if="getRecordStatus(item)">{{ getRecordStatus(item) }}</div>
          </div>
          <div class="service-grid">
            <div class="service-field" v-if="getRecordValue(item, ['order_no', 'number', 'order_number'])">
              <span>订单编号</span>
              <strong>{{ getRecordValue(item, ['order_no', 'number', 'order_number']) }}</strong>
            </div>
            <div class="service-field" v-if="getRecordValue(item, ['contacts', 'contact', 'nickname', 'user_name', 'name'])">
              <span>客户</span>
              <strong>{{ getRecordValue(item, ['contacts', 'contact', 'nickname', 'user_name', 'name']) }}</strong>
            </div>
            <div class="service-field" v-if="getRecordValue(item, ['address', 'service_address', 'install_address'])">
              <span>服务地址</span>
              <strong>{{ getRecordValue(item, ['address', 'service_address', 'install_address']) }}</strong>
            </div>
            <div class="service-field" v-if="getRecordValue(item, ['created_at', 'create_time', 'order_time'])">
              <span>下单时间</span>
              <strong>{{ getRecordValue(item, ['created_at', 'create_time', 'order_time']) }}</strong>
            </div>
            <div class="service-field" v-if="getRecordValue(item, ['visit_time', 'tolls_time', 'service_time'])">
              <span>上门时间</span>
              <strong>{{ getRecordValue(item, ['visit_time', 'tolls_time', 'service_time']) }}</strong>
            </div>
            <div class="service-field" v-if="getRecordValue(item, ['complete_time', 'finished_time', 'finish_time'])">
              <span>完成时间</span>
              <strong>{{ getRecordValue(item, ['complete_time', 'finished_time', 'finish_time']) }}</strong>
            </div>
            <div class="service-field" v-if="getRecordValue(item, ['score', 'worker_star', 'star'])">
              <span>评分</span>
              <strong>{{ getRecordValue(item, ['score', 'worker_star', 'star']) }} 分</strong>
            </div>
            <div class="service-field" v-if="getRecordValue(item, ['price', 'money', 'offer', 'amount'])">
              <span>金额</span>
              <strong>{{ getRecordValue(item, ['price', 'money', 'offer', 'amount']) }}</strong>
            </div>
          </div>
          <div class="service-remark" v-if="getRecordValue(item, ['remark', 'comment', 'evaluate', 'content'])">
            {{ getRecordValue(item, ['remark', 'comment', 'evaluate', 'content']) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baoIcon from '../../../../assets/images/bao2.png'
export default {
  name: 'master-item',
  props: {
    id: {
      type: Number,
      default: 0
    },
    thressMonthsCount: {
      type: [Number, String],
      default: 0
    },
    // 订单id
    order_id: {
      type: [Number, String],
      default: 0
    },
    oneMonthsCount: {
      type: [Number, String],
      default: 0
    },
    lastMonthNumber: {
      type: [Number, String],
      default: 0
    },
    worker_id: {
      type: [Number, String],
      default: 0
    },
    tolls_time: {
      type: String,
      default: ''
    },
    detail_worker_id: {
      type: [Number, String],
      default: 0
    },
    detail_status: {
      type: Number,
      default: 0
    },
    worker_order: {
      type: Number,
      default: 0
    },
    cooperateNumber: {
      type: Number,
      default: 0
    },
    score: {
      type: [Number, String],
      default: 0
    },
    phone: {
      type: String,
      default: ''
    },
    nickname: {
      type: String,
      default: ''
    },
    head_img: {
      type: String,
      default: ''
    },
    offer: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      baoIcon,
      serviceLoading: false,
      serviceLoaded: false,
      serviceRecords: [],
      finishedModalVisible: false,
      finishedLoading: false,
      finishedLoaded: false,
      finishedOrders: [],
      finishedPage: 1,
      finishedSize: 10,
      finishedTotal: 0
    }
  },
  created () {
    this.getServiceRecords()
  },
  methods: {
    getServiceRecords () {
      if (!this.worker_id) {
        this.serviceRecords = []
        this.serviceLoaded = true
        return
      }
      this.serviceLoading = true
      this.$request('6a1e73973fb01', {
        worker_id: this.worker_id
      }, 'get').then((res) => {
        const data = res.data.data || []
        this.serviceRecords = this.normalizeServiceRecords(data)
        this.serviceLoaded = true
      }).catch(() => {
        this.serviceRecords = []
      }).finally(() => {
        this.serviceLoading = false
      })
    },
    normalizeServiceRecords (data) {
      if (Array.isArray(data)) return data
      if (Array.isArray(data.list)) return data.list
      if (Array.isArray(data.data)) return data.data
      if (Array.isArray(data.records)) return data.records
      if (Array.isArray(data.order)) return data.order
      if (Array.isArray(data.orders)) return data.orders
      return []
    },
    getRecordValue (item, keys) {
      for (let i = 0; i < keys.length; i++) {
        const value = item && item[keys[i]]
        if (value !== undefined && value !== null && value !== '') {
          return value
        }
      }
      return ''
    },
    getRecordTitle (item, index) {
      return this.getRecordValue(item, ['title', 'order_title', 'service_name', 'product_model', 'type_name', 'class_name']) || `服务记录 ${index + 1}`
    },
    getRecordStatus (item) {
      return this.getRecordValue(item, ['status_name', 'status_text', 'msg', 'state_name'])
    },
    showFinishedOrders () {
      this.finishedModalVisible = true
      if (!this.finishedLoaded) {
        this.getFinishedOrders()
      }
    },
    getFinishedOrders () {
      if (!this.worker_id) {
        this.finishedOrders = []
        this.finishedTotal = 0
        this.finishedLoaded = true
        return
      }
      this.finishedLoading = true
      this.$request('690000000021', {
        worker_id: this.worker_id,
        page: this.finishedPage,
        size: this.finishedSize,
        class_id: 0
      }).then((res) => {
        const data = res.data.data || []
        this.finishedOrders = this.normalizeFinishedOrders(data)
        this.finishedTotal = this.getFinishedTotal(data)
        this.finishedLoaded = true
      }).catch(() => {
        this.finishedOrders = []
        this.finishedTotal = 0
      }).finally(() => {
        this.finishedLoading = false
      })
    },
    normalizeFinishedOrders (data) {
      if (Array.isArray(data)) return data
      if (Array.isArray(data.list)) return data.list
      if (Array.isArray(data.data)) return data.data
      if (Array.isArray(data.records)) return data.records
      if (Array.isArray(data.order)) return data.order
      if (Array.isArray(data.orders)) return data.orders
      return []
    },
    getFinishedTotal (data) {
      if (data && (data.count || data.count === 0)) return Number(data.count)
      if (data && (data.total || data.total === 0)) return Number(data.total)
      if (data && (data.total_count || data.total_count === 0)) return Number(data.total_count)
      return this.normalizeFinishedOrders(data).length
    },
    getFinishedTitle (item, index) {
      return this.getRecordValue(item, ['title', 'order_title', 'service_name', 'product_model', 'type_name', 'class_name']) || `完工记录 ${index + 1}`
    },
    getFinishedImages (item) {
      const value = this.getRecordValue(item, ['finished_img', 'finish_img', 'finished_images', 'finish_images', 'complete_img', 'complete_images', 'img', 'imgs', 'images'])
      if (Array.isArray(value)) return value.filter(Boolean)
      if (typeof value === 'string') {
        return value.split(',').map((img) => img.trim()).filter(Boolean)
      }
      return []
    },
    changeFinishedPage (page) {
      this.finishedPage = page
      this.getFinishedOrders()
    },
    assign () {
      let vm = this
      this.$request('6123553996402', {
        offer_id: vm.id
      }).then((res) => {
        // this.$emit('assignSuccess')
        this.$router.push({
        	name: 'order_list'
        })
        this.$message.success('操作成功')
      })
    },
    gotoPay () {
      console.log('---')
      this.$emit('gotoPay')
    }
  }
}
</script>

<style scoped lang="less">
.master-item {
  width: 100%;
  padding: 10px 10px;
  border: 1px solid #f5f7f9;
  margin: 0 auto;
  margin-bottom: 20px;

  .master-card {
    width: 100%;
    margin: 0 auto;
    display: flex;

    .img {
      width: 120px;
      height: 120px;
    }

    .master-info {
      width: 30%;
      margin-left: 10px;
      min-height: 120px;
      //display: flex;
      //flex-direction: column;
      //justify-content: space-between;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-size: 14px;
        display: flex;
        align-items: center;
        .moneySave {
          margin-left: 14px;
        }
      }
      .desc {
        display: flex;
        align-items: center;
      }
      .desc,
      .num {
        font-size: 10px;
        color: #999999;
      }
      .textarea {
        background-color: rgba(#999999, 0.2);
        font-size: 10px;
        padding:8px;

        display: flex;
        &-name{
          width: 100px;
        }
      }

      .ivu-tag {
        display: inline-block;
        flex: none;
        width: 55px;
      }

      .num {
        color: #999;
      }
    }

    .contact {
      width: 25%;
      padding: 0 40px;

      .text1 {
        display: inline-block;
        border: 1px solid rgba(#999999, 0.3);
        padding: 8px 24px;
        font-size: 12px;
      }
    }

    .handle {
      flex: 1;
      text-align: right;

      .btn {
        width: 82px;
        height: 26px;
        padding: 0;
        margin-bottom: 5px;
      }

      .finish-btn {
        width: 82px;
        height: 26px;
        padding: 0;
        display: block;
        margin-left: auto;
        margin-right: 0;
        margin-bottom: 5px;
        color: #fb9e2f;
        border-color: #fb9e2f;
        background: #fff8ef;
      }

      .info-btn {
        cursor: pointer;
      }

      .tips {
        font-size: 12px;
        color: #bfbfbf;
      }
    }
  }
}
// TODO 2022/7/22 新增css
.mrs {
  display: inline-block;
  width: 120px;
  margin-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pions {
  cursor: pointer;
}
.baoMoney {
  width: 16px;
  height: 16px;
  margin-top: 2px;
	background-color: #f8f8f8;
	border-radius: 8rpx;
}

.service-record-wrap {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #eee;
}

.service-record-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  margin-bottom: 10px;
  border: 1px solid #f3e1cc;
  background: #fff8ef;
}

.service-record-title {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.service-record-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #999;
}

.service-record-total {
  color: #fb9e2f;
  font-size: 13px;
}

.service-loading,
.service-empty {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background: #fafafa;
}

.service-list {
  max-height: 260px;
  overflow-y: auto;
}

.service-item {
  padding: 14px 16px;
  margin-bottom: 10px;
  border: 1px solid #eef0f3;
  background: #fff;
}

.service-item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.service-name {
  font-size: 15px;
  color: #333;
  font-weight: 600;
}

.service-status {
  padding: 2px 8px;
  color: #fb9e2f;
  font-size: 12px;
  background: #fff8ef;
  border: 1px solid #f3e1cc;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
}

.service-field {
  display: flex;
  min-width: 0;
  font-size: 12px;
  line-height: 20px;
}

.service-field span {
  flex: 0 0 64px;
  color: #999;
}

.service-field strong {
  min-width: 0;
  color: #333;
  font-weight: normal;
  word-break: break-all;
}

.service-remark {
  margin-top: 10px;
  padding: 8px 10px;
  color: #666;
  font-size: 12px;
  line-height: 20px;
  background: #f7f8fa;
}

.finished-panel {
  min-height: 280px;
}

.finished-loading,
.finished-empty {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background: #fafafa;
}

.finished-list {
  max-height: 560px;
  overflow-y: auto;
}

.finished-item {
  padding: 14px;
  margin-bottom: 12px;
  border: 1px solid #eef0f3;
  background: #fff;
}

.finished-meta {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.finished-title {
  flex: 0 0 auto;
  color: #333;
  font-size: 15px;
  font-weight: 600;
}

.finished-desc {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px 14px;
  color: #999;
  font-size: 12px;
  line-height: 20px;
}

.finished-images {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.finished-image {
  width: 100%;
  height: 112px;
  border: 1px solid #eef0f3;
  background: #f7f8fa;
}

.finished-no-image {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bfbfbf;
  background: #fafafa;
}

.finished-page {
  margin-top: 12px;
  text-align: right;
}
</style>
